// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__3FoOO","modalFooterButton":"ModalNotes_modalFooterButton__19aZc"};